import { FastenerSpec, UltraRailMountingType } from './UltraRailTypes'

const RAFTER_FASTENERS: Record<string, FastenerSpec[]> = {
  '242-10056': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-10057': [{ code: '242-10066', qtyPerAttachment: 2 }],
  '242-10058': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-01220': [{ code: '242-92266', qtyPerAttachment: 1 }],
  '242-01223': [
    { code: '242-02168', qtyPerAttachment: 1 },
    { code: '242-92266', qtyPerAttachment: 1 },
  ],
  '242-01239': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-01247': [{ code: '242-02168', qtyPerAttachment: 2 }],
  '242-01248': [{ code: '242-02168', qtyPerAttachment: 2 }],
  '242-02158': [{ code: '242-02168', qtyPerAttachment: 1 }], // Metal Roof Base w/ L Foot – lag into framing
  '242-02163': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-02167': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-02729': [{ code: '242-02168', qtyPerAttachment: 2 }],
  '242-10016': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-10017': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-10018': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-10020': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-10021': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-10022': [{ code: '242-02168', qtyPerAttachment: 1 }],
  '242-10038': [
    { code: '242-02168', qtyPerAttachment: 1 },
    { code: '242-10066', qtyPerAttachment: 2 },
  ],
  '242-10039-USA': [{ code: 'Type 17-AB Milled Point', qtyPerAttachment: 4 }], // Type 17-AB Milled Point – no SKU in Slab
  '242-10041-USA': [{ code: 'Type 17-AB Milled Point', qtyPerAttachment: 4 }],
  '242-10044-USA': [{ code: 'Type 17-AB Milled Point', qtyPerAttachment: 3 }],
}

const DECK_FASTENERS: Record<string, FastenerSpec[]> = {
  '242-10057': [{ code: '242-10066', qtyPerAttachment: 4 }],
  '242-10058': [{ code: '242-10035', qtyPerAttachment: 2 }],
  '242-01248': [{ code: '242-10066', qtyPerAttachment: 8 }],
  '242-02729': [{ code: '242-10066', qtyPerAttachment: 8 }],
  '242-10016': [{ code: '242-10066', qtyPerAttachment: 6 }],
  '242-10017': [{ code: '242-10066', qtyPerAttachment: 6 }],
  '242-10018': [{ code: '242-10066', qtyPerAttachment: 6 }],
  '242-10038': [
    { code: '242-10035', qtyPerAttachment: 2 },
    { code: '242-10066', qtyPerAttachment: 4 },
  ],
  '242-10039-USA': [{ code: 'Type 17-AB Milled Point', qtyPerAttachment: 4 }],
  '242-10041-USA': [{ code: 'Type 17-AB Milled Point', qtyPerAttachment: 4 }],
  '242-10044-USA': [{ code: 'Type 17-AB Milled Point', qtyPerAttachment: 3 }],
}

const METAL_FASTENERS: Record<string, FastenerSpec[]> = {
  '242-05159': [], // Wide Base Seam Clamp – no screws
  '242-10039-USA': [{ code: 'Self Drilling Screw - Hex Washer Head', qtyPerAttachment: 4 }],
  '242-10041-USA': [{ code: 'Self Drilling Screw - Hex Washer Head', qtyPerAttachment: 4 }],
  '242-10042-USA': [{ code: 'Hex head with EPDM rubber sealing washer', qtyPerAttachment: 4 }],
  '242-10043-USA': [], // S-5-N Mini – no screws
  '242-10044-USA': [{ code: 'Self Drilling Screw - Hex Washer Head', qtyPerAttachment: 2 }],
}

export const FASTENERS_BY_STYLE: Record<UltraRailMountingType, Record<string, FastenerSpec[]>> = {
  Rafter: RAFTER_FASTENERS,
  Decking: DECK_FASTENERS,
  Metal: METAL_FASTENERS,
}

/**
 * Returns fastener spec(s) for the given attachment SKU and attachment style.
 * Empty array if attachment has 0 fasteners (e.g. Wide Base Seam Clamp) or unknown attachment/style.
 */
export function getFastenersForAttachment(attachmentCode: string, mountingType: UltraRailMountingType): FastenerSpec[] {
  if (!attachmentCode || !mountingType) return []
  const styleMap = FASTENERS_BY_STYLE[mountingType]
  const specs = styleMap[attachmentCode]
  return specs ?? []
}
